import { pdkAxios } from '@/lib/pdk-axios';
import { Deal } from '@/models/registry';
import { favoriteStore } from '@/models/stores';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import useRemoveFromFavorites from './use-remove-from-favorites';
import { useUser } from './use-user';

const useFavoriteMutation = (deal: Deal) => {
  const queryClient = useQueryClient();
  const favorited = deal ? favoriteStore.isFavoritedByUser(deal.id) : false;
  const user = useUser();

  const addToFavoritesMutation = useMutation({
    onMutate: async (id: string) => {
      // Mutate in Favorite store
      favoriteStore.add({
        id,
        deal_id: deal.id,
        user_id: user.id,
        hub_id: deal.hub?.id ?? '',
      });
    },
    mutationFn: async (id: string) => {
      const response = await pdkAxios
        .post(`/deals/${deal.id}/favorites/create`, { id })
        .catch((e) => {
          console.error('Error adding to favorites', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: () => {
      // const realTaskPersistedToBackend = data;
      // setDialogIsOpen(false);
      // tasksStore.replaceTask(task.id, realTaskPersistedToBackend);
      // setOptimisticCreateTaskId(generateOptimisticId());
      // // UX NOTE: we want to assign the task to the deal immediately after it is created
      // // so that the user can see the task in the deal immediately
      // assignTaskMutation.mutate({
      //   task: {
      //     id: realTaskPersistedToBackend.id,
      //     title: realTaskPersistedToBackend.title,
      //     description: realTaskPersistedToBackend.description,
      //   },
      // });
    },
    onError: (error, variables) => {
      console.error('Failed to create favorite', error, variables);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['favorites'] });
      queryClient.invalidateQueries({ queryKey: ['deal', deal.short_id] });
    },
  });

  const removeFromFavoritesMutation = useRemoveFromFavorites({
    dealId: deal?.id,
    dealShortId: deal?.short_id,
  });

  const toggleFavorite = useCallback(() => {
    if (favorited) {
      removeFromFavoritesMutation.mutate();
    } else {
      addToFavoritesMutation.mutate(uuidv4());
    }
  }, [favorited, removeFromFavoritesMutation, addToFavoritesMutation]);

  return {
    toggleFavorite,
  };
};

export default useFavoriteMutation;
